import { List, ListItem, ListItemButton, Skeleton, styled, useTheme } from '@mui/material';

export type VideosSkeletonProps = {
  videoCount?: number;
};

const Content = styled('div')();

export const VideosSkeleton = ({ videoCount = 10 }: VideosSkeletonProps) => {
  const theme = useTheme();

  return (
    <List
      sx={{
        color: theme.mainTextPrimary,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: 0,
        width: '100%',
      }}
    >
      {Array.from({ length: videoCount }).map((_, index) => (
        <ListItem disablePadding key={index}>
          <ListItemButton
            disableRipple
            sx={{
              alignItems: 'flex-start',
              boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2)',
              padding: theme.spacing(2),
              width: '100%',
            }}
          >
            <Skeleton
              sx={{
                [theme.breakpoints.up('sm')]: {
                  height: '129px',
                  width: '230px',
                },
                borderRadius: theme.spacing(1),
                flexShrink: 0,
                height: '84px',
                marginBottom: theme.spacing(1),
                marginRight: theme.spacing(2),
                width: '150px',
              }}
              variant="rectangular"
            />
            <Content>
              <Skeleton
                sx={{
                  borderRadius: theme.spacing(1),
                  height: '24px',
                  marginBottom: theme.spacing(1),
                  width: '250px',
                }}
                variant="rectangular"
              />
              <Skeleton
                sx={{
                  borderRadius: theme.spacing(1),
                  height: '20px',
                  marginBottom: theme.spacing(1),
                  width: '150px',
                }}
                variant="rectangular"
              />
              <Skeleton
                sx={{
                  borderRadius: theme.spacing(1),
                  height: '20px',
                  width: '200px',
                }}
                variant="rectangular"
              />
            </Content>
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};
